import * as React from 'react';
import { Recaptcha } from '../../recaptcha/recaptcha';
import { wrapWithTooltip } from '../wrap_with_tooltip';

export interface IRecaptchaFieldProps {
  sitekey: string;
  isValid: boolean;
  theme?: 'dark' | 'light';
  type?: 'audio' | 'image';
  size?: 'compact' | 'normal';
  tabindex?: number;
  onExecute?(response: string): void;
  onExpired?(): void;
}

const RecaptchaField = (props: IRecaptchaFieldProps) =>
  props.isValid ? <Recaptcha {...props} /> : wrapWithTooltip(<Recaptcha {...props} />, 'Подтвердите, что вы не робот');

export { RecaptchaField };
